import { custom_event } from './dom.js';

export let current_component;

/*                  */
export function set_current_component(component) {
	current_component = component;
}

export function get_current_component() {
	if (!current_component) throw new Error('Function called outside component initialization');
	return current_component;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function beforeUpdate(fn) {
	get_current_component().$$.before_update.push(fn);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function onMount(fn) {
	get_current_component().$$.on_mount.push(fn);
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function afterUpdate(fn) {
	get_current_component().$$.after_update.push(fn);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function onDestroy(fn) {
	get_current_component().$$.on_destroy.push(fn);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function createEventDispatcher() {
	const component = get_current_component();
	return (type, detail, { cancelable = false } = {}) => {
		const callbacks = component.$$.callbacks[type];
		if (callbacks) {
			/*                                                         */
			/*                                 */
			const event = custom_event(/*                 */ (type), detail, { cancelable });
			callbacks.slice().forEach((fn) => {
				fn.call(component, event);
			});
			return !event.defaultPrevented;
		}
		return true;
	};
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function setContext(key, context) {
	get_current_component().$$.context.set(key, context);
	return context;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function getContext(key) {
	return get_current_component().$$.context.get(key);
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function getAllContexts() {
	return get_current_component().$$.context;
}

/**
 *
 *
 *
 *
 *
 *
 */
export function hasContext(key) {
	return get_current_component().$$.context.has(key);
}

/*                                          */
/*                                           */
/*                        */
/**
 *
 *
 *
 */
export function bubble(component, event) {
	const callbacks = component.$$.callbacks[event.type];
	if (callbacks) {
		/*         */
		callbacks.slice().forEach((fn) => fn.call(this, event));
	}
}
